export default {
  title: 'FightCamp Monthly Membership',
  id: 'fightcamp_subscription',
  price: 0,
  category: 'subscription',
  description: '',
  img_url: '',
};
